import React, { useState } from "react";
import api from "../../../services/api.js";

const SyncPppSecretByUsermanId = ({ usermanId, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleSync = async () => {
    if (!usermanId) return;

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const res = await api.get(`/ppp-secret/sync/${usermanId}`, {
        headers: { Authorization: token },
      });

      alert(
        `Sync berhasil\nDevice: ${res.data.data.device}\nTotal Secret: ${res.data.data.total_secret}`
      );

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(error);
      alert(
        error.response?.data?.message ||
          "Gagal melakukan sinkronisasi PPP Secret"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleSync}
      disabled={loading}
      className={`px-4 py-2 rounded text-white transition ${
        loading
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-teal-600 hover:bg-teal-700"
      }`}
    >
      {loading ? "Syncing..." : "Sync PPP Secret"}
    </button>
  );
};

export default SyncPppSecretByUsermanId;
